import PrimaryContactDetails from "./primary-contact-details";

export default PrimaryContactDetails;
